var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "page-common-form" }, [
    _c("div", { staticClass: "vn-grid-small" }, [
      _vm.userInfo.id
        ? _c("div", { staticClass: "page-common-form__box" }, [
            _c("h1", { staticClass: "page-common-form__h" }, [
              _vm._v(_vm._s(_vm.userInfo.userName) + "님의 데일리 학습 기록"),
            ]),
            _vm._v(" "),
            !_vm.completed
              ? _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submitForm($event)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "vn-form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "label",
                          attrs: { for: "page-common-form-class" },
                        },
                        [_vm._v("수강한 온라인 강의명")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData.courseTitle,
                            expression: "formData.courseTitle",
                          },
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "text",
                          id: "page-common-form-class",
                          required: "",
                        },
                        domProps: { value: _vm.formData.courseTitle },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.formData,
                              "courseTitle",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v("수강 기록을 제출하실 강의명을 입력해주세요."),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vn-form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "label",
                          attrs: { for: "page-common-form-clip" },
                        },
                        [_vm._v("강의 클립 이름")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData.clipTitle,
                            expression: "formData.clipTitle",
                          },
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "text",
                          id: "page-common-form-clip",
                          required: "",
                        },
                        domProps: { value: _vm.formData.clipTitle },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.formData,
                              "clipTitle",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(
                          "수강 기록을 제출하실 강의 클립 이름을 입력해주세요."
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vn-form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "label",
                          attrs: { for: "page-common-form-contents" },
                        },
                        [_vm._v("학습 내용 정리")]
                      ),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.formData.contents,
                            expression: "formData.contents",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "textarea",
                        attrs: {
                          id: "page-common-form-contents",
                          rows: "100",
                          required: "",
                        },
                        domProps: { value: _vm.formData.contents },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.formData,
                              "contents",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(
                          "배운 내용을 간략하게 정리합니다. 공백 미포함 100자 이상의 내용을 작성해야 합니다."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "length-check" }, [
                        _vm._v(
                          _vm._s(_vm.formData.contents.length) +
                            "자 / " +
                            _vm._s(_vm.maxLength) +
                            "자"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.error
                      ? _c("p", { staticClass: "error" }, [
                          _vm._v("에러! 잠시 후 다시 시도해주세요."),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--lg btn--wide btn--curve",
                          attrs: { type: "submit", disabled: _vm.invalided },
                        },
                        [_vm._v("제출하기")]
                      ),
                    ]),
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "page-common-form__message" },
                  [
                    _c("mission-icon"),
                    _vm._v(" "),
                    _c("p", { staticClass: "message" }, [
                      _vm._v(
                        _vm._s(_vm.userInfo.userName) +
                          "님의 " +
                          _vm._s(_vm.formData.courseTitle) +
                          " 학습 기록을 제출하였습니다."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn--dimmed btn--lg btn--wide btn--curve",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.resetForm()
                            },
                          },
                        },
                        [_vm._v("\n            다시 작성하기\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn--lg btn--wide btn--curve",
                          attrs: { href: "/" },
                        },
                        [_vm._v("홈으로 이동")]
                      ),
                    ]),
                  ],
                  1
                ),
          ])
        : _c("div", { staticClass: "page-common-form__box" }, [
            _c(
              "div",
              { staticClass: "page-common-form__message" },
              [
                _c("h1", { staticClass: "page-common-form__h" }, [
                  _vm._v("데일리 학습 기록"),
                ]),
                _vm._v(" "),
                _c("mission-icon"),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("p", { staticClass: "message" }, [
                  _vm._v(
                    "\n          패스트캠퍼스 온라인 60만원 환급 도전! 수강 기록을 작성하여 일일 미션을 수행을 완료하시려면, 패스트캠퍼스\n          계정에 로그인을 해주세요! 일일 미션을 달성할 경우 월 5만 원이 환급 됩니다. (5만 원X6개월 = 총 30만 원)\n        "
                  ),
                ]),
              ],
              1
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn-group" }, [
      _c(
        "a",
        {
          staticClass: "btn btn--lg btn--wide btn--curve",
          attrs: { href: "/auth/login" },
        },
        [_vm._v("로그인하러 가기")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }